import { IsServerSideRendering } from '../../utilities';
import { checkIfDismissedCookieExists, isWithinDateRange, shouldDisplayOnPage } from '../../utilities/bannersAndModals';
import theme from '../../theme';

export const shouldDisplayPromotion = (promotion, geolocation) => {
  if (IsServerSideRendering) {
    return false;
  }

  if (!promotion || !geolocation) return false;

  const shouldDisplayOnCurrentPage = shouldDisplayOnPage(
    promotion.includedPages, promotion.excludedPages
  );

  const isExcludedLocation = promotion.excludedStates
    && promotion.excludedStates.indexOf(geolocation.state) > -1;

  const hasIncludedLocationIds = promotion.includedLocationIds
    && promotion.includedLocationIds.length;
  const isInIncludedLocationIds = hasIncludedLocationIds
    && promotion.includedLocationIds.indexOf(geolocation.zip5) > -1; // TODO: location IDs

  const hasIncludedStates = promotion.includedStates && promotion.includedStates.length;
  const isInIncludedStates = hasIncludedStates
    && promotion.includedStates.indexOf(geolocation.state) > -1;
  const hasIncludedVariables = hasIncludedLocationIds || hasIncludedStates;

  const isIncludedLocation = !hasIncludedVariables
    || isInIncludedLocationIds
    || isInIncludedStates;

  return promotion.isEnabled
    && shouldDisplayOnCurrentPage
    && isWithinDateRange(promotion.dateRange)
    && !isExcludedLocation
    && isIncludedLocation;
};

export const shouldDisplayPromotionModal = promotion => {
  if (IsServerSideRendering || !promotion.modal) {
    return false;
  }

  const {
    modal: {
      showOnLoad,
      showOnLoadDesktopMinWidth,
      showOnLoadDesktopDelay,
      showOnLoadMobileDelay,
      includedPages,
      excludedPages
    }
  } = promotion;

  const shouldDisplayOnCurrentPage = shouldDisplayOnPage(
    includedPages, excludedPages
  );

  // eslint-disable-next-line
  const isDesktop = screen.width >= (showOnLoadDesktopMinWidth || theme.breakpoints.values.sm);
  const delayOnDesktop = isDesktop && showOnLoadDesktopDelay;
  const delayOnMobile = !isDesktop && showOnLoadMobileDelay;

  return !checkIfDismissedCookieExists(promotion.modal.cookieName)
    && showOnLoad
    && shouldDisplayOnCurrentPage
    && !delayOnDesktop
    && !delayOnMobile;
};

export const shouldDisplayCampaignPromotion = (promotion, { geolocation, discountsForFavorites }) => {
  if (IsServerSideRendering) {
    return false;
  }

  const shouldDisplayOnCurrentPage = shouldDisplayOnPage(
    promotion.includedPages, promotion.excludedPages
  );

  const isExcludedLocation = promotion.excludedStates
    && promotion.excludedStates.indexOf(geolocation.state) > -1;

  const hasIncludedStates = promotion.includedStates && promotion.includedStates.length;
  const isInIncludedStates = hasIncludedStates
    && promotion.includedStates.indexOf(geolocation.state) > -1;

  const isIncludedLocation = !hasIncludedStates || isInIncludedStates;

  const campaignDiscounts = discountsForFavorites.filter(discount => discount.type === 'Campaign') || [];
  const shouldDisplayForCampaign = campaignDiscounts.length > 0;

  return promotion.isEnabled
    && shouldDisplayForCampaign
    && shouldDisplayOnCurrentPage
    && !isExcludedLocation
    && isIncludedLocation;
};

export default { shouldDisplayPromotion, shouldDisplayPromotionModal };
